/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faRotate } from "@fortawesome/free-solid-svg-icons";
import FinancialIcon from "../../../assets/icons/icon_reporting_financials_white-01.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

export default function FinancialWidget({ processGUID, projectUUID }) {
  const [loading, setLoading] = useState(false);
  const [financialData, setFinancialData] = useState({
    AccountBalance: "2,345.00",
    OverdueInvoices: "1",
    LatestInvoiceDue: "29/02/2024",
    CurrentMonthMessaging: "786.45",
    SubscriptionRenewalDate: "18/07/2024",
  });

  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      {loading && (
        <div className="position-absolute top-0 start-0 h-100 w-100 text-bg-light bg-opacity-50 z-1">
          <div className="position-absolute top-50 start-50 translate-middle text-white">
            <FontAwesomeIcon icon={faRotate} spin size="5x" />
          </div>
        </div>
      )}
      <div className="d-flex p-3 align-items-center widget-header">
        <FinancialIcon width={20} className="white opacity-50" />
        <h6 className="m-0 mx-2 small fw-bold">FINACIAL</h6>
        <HelpButton helpKey="widget-financial" iconClassName="white" />
      </div>
      <NewFeature>
        <div className="mt-2">
          {[
            {
              label: "Account Balance",
              value: <div>-£{financialData.AccountBalance} </div>,
            },
            {
              label: "Overdue invoices",
              value: `${financialData.OverdueInvoices} `,
            },
            {
              label: <div>Latest invoice due</div>,
              value: (
                <div className="fw-normal fs-6">
                  {financialData.LatestInvoiceDue}
                </div>
              ),
            },
            {
              label: "Current month messaging",
              value: <div>£{financialData.CurrentMonthMessaging}</div>,
            },
            {
              label: <div className="mb-5">Subscription Renewal Date</div>,
              value: (
                <div className="fw-normal fs-6">
                  {financialData.SubscriptionRenewalDate}
                </div>
              ),
            },
          ].map((r, i) => (
            <React.Fragment key={i}>
              <hr className="m-1" />
              <div className="d-flex justify-content-between px-3">
                <span className="opacity-50 fw-bold p-1">{r.label}</span>
                <h3 className="fw-bold m-0 p-1">{r.value}</h3>
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="flex-grow-1"></div>

        <div className="p-3 d-flex justify-content-end">
          <hr />
          <button
            type="button"
            className="btn btn-light btn-sm px-3 rounded-pill text-purple fw-bold mx-1"
          >
            PAY OUTSTANDING INVOICES{" "}
            <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          </button>
        </div>
      </NewFeature>
    </div>
  );
}
